import { render, staticRenderFns } from "./sidebar-etc.vue?vue&type=template&id=838b46e2&"
import script from "./sidebar-etc.vue?vue&type=script&lang=js&"
export * from "./sidebar-etc.vue?vue&type=script&lang=js&"
import style0 from "./sidebar-etc.vue?vue&type=style&index=0&id=838b46e2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports